window.SLDS = window.SLDS || {};

window.SLDS.accordion = (id) => ({
  toggle(event) {
    // Get current path.
    const path = `${window.location.pathname}${window.location.search}`;

    // Handle open accordion.
    if (event.newState == "open") {
      // Add hash to the URL.
      history.replaceState(null, document.title, `${path}#${id}`);
    }

    // Handle closed accordion.
    if (event.newState == "closed") {
      // Remove hash from the URL.
      history.replaceState(null, document.title, path);
    }
  },
});
